module.exports = __webpack_public_path__ + "img/cb3p-r-1.8f58c728.gif";